import { createContext, useState } from "react";
import useStateRef from "react-usestateref";

export const EquipamentoContext = createContext({});

export function EquipamentosProvider({ children }) {
	const [codigoEquipamentoCtx, setCodigoEquipamentoCtx] = useState(null);
	const [equipamentoCtx, setEquipamentoCtx] = useState(null);
	const [equipamentoFoiEditado, setEquipamentoFoiEditado, equipamentoFoiEditadoRef] = useStateRef(false);

	const salvarNovoEquipamento = (id, equipamento) => {
		setCodigoEquipamentoCtx(id);
		setEquipamentoCtx(equipamento);
	};

	const providerValue = {
		codigoEquipamentoCtx,
		equipamentoCtx,
		salvarNovoEquipamento,
		equipamentoFoiEditado,
		setEquipamentoFoiEditado,
		equipamentoFoiEditadoRef
	};

	return (
		<EquipamentoContext.Provider value={providerValue}>
			{children}
		</EquipamentoContext.Provider>
	);
}